import React from 'react';
import { FlagProvider } from '@unleash/proxy-client-react';

const FlagProviderWrapper = ({ children }) => {
  const featureFlagsClientConfig = {
    url: UNLEASH_URL,
    clientKey: UNLEASH_CLIENT_KEY,
    refreshInterval: 15,
    appName: 'sportograf_frontend',
  };

  const unleashConfig = {
    ...featureFlagsClientConfig,
  };

  return <FlagProvider config={unleashConfig}>{children}</FlagProvider>;
};

export default FlagProviderWrapper;
